import React from 'react';
import './MainContent.css';
const MainContent = () => {
  return (
    <main className="main-content">
      <img src='/assets/images/familia.jpg' alt="Bienvenido" className="main-image" />
      <div className="welcome-text">
        <h1>CENTRO AVANZADO DE IMPLANTOLOGÍA MAXILOFACIAL ANTOFAGASTA</h1>
        <p>Bienvenido a nuestro Centro de Implantes Dentales</p>
        
        <button className="agendar-btn" onClick={() => window.open('https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1', '_blank')}>
          AGENDA TU CITA
        </button>
      </div>
    </main>
  );
};


export default MainContent; 